import Vue from 'vue'
import httpManager from "../../util/common";
import china_area_code from "../../../static/json/100000_full_geo.json"
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

Vue.config.productionTip = false

let vm = {
  delimiters: ['{', '}'],
  name: 'entity-home-area-map',
  props: ['oaid'],
  data: () => {
    return {
      province_list: [],
      GDPSpeed: {},
      extremum: {max: null},
      divloading: false,
      map: null, // 地图
      geo_layer: null,  // 地域块对象
      info_control: null, //地图右上角信息控件
    }
  },
  mounted () {
    this.getEntityHomeAreaMapData()
  },
  methods: {
    getEntityHomeAreaMapData () {
      let self = this
      self.divloading = true
      let oaid = this.oaid
      let params = new Map()
      params.set('oaid', oaid)
      params.set('type', 'customer')
      httpManager('entity_sc_region', params)
        .then(response => {
          if (response.data.data) {
            self.GDPSpeed = {}
            if (response.data.data.result.length > 0) {
              let currentDate = new Date();
              let currentYear = currentDate.getFullYear();
              let yearList = []
              self.extremum['max'] = 0
              let i = 0
              for (i = 0; i < response.data.data.result.length; i++) {
                if (response.data.data.result[i]['reporting_year'] >= currentYear) {
                  continue
                }
                yearList.push(response.data.data.result[i]['reporting_year'])
              }
              let year = yearList[0]

              for (i = 0; i < response.data.data.result.length; i++) {
              if (response.data.data.result[i]['reporting_year'] === year) {
                self.GDPSpeed[response.data.data.result[i]['region']] = response.data.data.result[i]['amount_cny']
                if (response.data.data.result[i]['amount_cny'] > self.extremum['max']) {
                  self.extremum['max'] = response.data.data.result[i]['amount_cny']
                }
              }
            }

            }
            // self.drawEntityHomeAreaMap()
            self.leafletMap()
            self.divloading = false
          }
        })
        .catch(error => {
          console.log(error)
          self.divloading = false
        })
    },
    getPointsStyle (adcode) {
      // 面的线的样式
      let style = {color: 'black', weight: 1, opacity: 0.5, fillColor: 'rgb(255, 255, 255)', fillOpacity: 0.8}
      let gdp = this.GDPSpeed[adcode]
      if (gdp) {
        let rg = 255 - Math.ceil(gdp * 20 / this.extremum['max']) * 255 / 20
        style['fillColor'] = 'rgb(255,' + rg + ',' + rg + ')'
      }
      return style
    },
    leafletMap () {
      if( !this.map ) {
        this.map = L.map('entity-home-area-map', {
          center: [35, 110],
          zoom: 3,
          zoomControl: false,
          doubleClickZoom: false,
          fillColor: '#fff',
          fill: '#fff',
        })

        this.initInfoControl()
        this.info_control.addTo(this.map)
      } else {
        this.map.removeLayer(this.geo_layer)
      }
      this.geo_layer = L.geoJSON(china_area_code, {
        style: this.style,
        onEachFeature: this.onEachFeature
      }).addTo(this.map)
    },
    // 地图获取颜色，在style中调用
    getColor(adcode) {
      let color = '#fdfdfd'
      let gdp = this.GDPSpeed[adcode]
      if (gdp) {
        let rg = 255 - Math.ceil(gdp * 20 / this.extremum['max']) * 255 / 20
        color = 'rgb(255,' + rg + ',' + rg + ')'
      }
      return color;
    },
    // 地图获取样式
    style(feature) {
      return {
        fillColor: this.getColor(feature.properties.adcode),
        weight: 2,
        opacity: 1,
        color: '#7e7e7b',
        dashArray: '3',
        fillOpacity: 1
      }
    },
    // 初始化地图右上角信息控件
    initInfoControl() {
      this.info_control = L.control()
      this.info_control.onAdd = function(map) {
        this._div = L.DomUtil.create('div', 'map-info'); // create a div with a class "info"
        this.update();
        return this._div;
      }
      this.info_control.update = function(props) {
        let name = props? props.name : "中华人民共和国"
        this._div.innerHTML = '<h4>China</h4>' + 
          '<b>' + name +'</b><br />'
      }
    },
    // 地图相关事件
    onEachFeature(feature, layer) {
      layer.on({
        mouseover: this.highlightFeature,
        mouseout: this.resetHighlight,
        click: this.zoomToFeature
      })
    },
    // 地图触碰高亮，在onEachFeature中调用
    highlightFeature(e) {
      var layer = e.target
      
      layer.setStyle({
        weight: 3,
        color: '#d0d1d2',
        dashArray: '',
        fillOpacity: 0.7
      })
      if(!L.Browser.ie && !L.Browser.opera && !L.Browser.edge){
        layer.bringToFront()
      }

      this.info_control.update(layer.feature.properties)
    },
    // 地图移除高亮，在onEachFeature中调用
    resetHighlight(e) {
      this.geo_layer.resetStyle(e.target);
      this.info_control.update()
    },
    // 地图点击放大板块，在onEachFeature中调用
    zoomToFeature(e) {
      this.map.fitBounds(e.target.getBounds())
    },
  }
}
Vue.component('entity-home-area-map', vm)
export default vm



// WEBPACK FOOTER //
// ./src/entity/js/entity_home_area_map.js